import { useAction, useAtom } from '@reatom/npm-react'
import { useTranslation } from 'react-i18next'
import styled, { css } from 'styled-components'

import { CurrencyIcon } from '@root/entities/currency/ui'
import { ControlsQuickOption } from '@root/features/trade/trading-controls/ui/common'
import { Input } from '@root/shared/ui-kit'

import type { Pair } from '@root/entities/pair'
import type { CurrencyInputModel } from '@root/features/currency/currency-input-reatom'

type Props = {
  pair: Pair.PairMinimal
  amountInputModel: CurrencyInputModel
}

const BUY_QUICK_OPTIONS = [0.01, 0.02, 0.5, 1]

export const TradingControlsBuyAmount: React.FC<Props> = ({
  pair,
  amountInputModel,
}) => {
  const { t } = useTranslation()
  const [amount] = useAtom(amountInputModel.amountAtom)
  const [amountRaw] = useAtom(amountInputModel.amountRawAtom)
  const setBuyAmountRaw = useAction(amountInputModel.setAmountRawAction)

  const renderQuickOptions = () => (
    <QuickOptions>
      {BUY_QUICK_OPTIONS.map((it) => (
        <ControlsQuickOption
          title={it}
          key={it}
          active={amount.eq(it)}
          onClick={() => setBuyAmountRaw(it.toString())}
        />
      ))}
    </QuickOptions>
  )

  return (
    <Root>
      <Input
        numeric
        startContent={
          <StartContent>
            <QuickOptions>{renderQuickOptions()}</QuickOptions>
            <span>{t('common.amount')}</span>
          </StartContent>
        }
        decimalScale={pair.base.decimals}
        onChange={(e) => setBuyAmountRaw(e.target.value)}
        value={amountRaw}
        size="m"
        placeholder="0"
        endContent={
          <CurrencyIcon
            withGoogleLens={false}
            currency={pair.base}
            size={24}
            css={css`
              justify-self: end;
            `}
          />
        }
      />
    </Root>
  )
}

const Root = styled.div`
  --input-padding-inline: 5px 6px;
  gap: 6px;

  display: grid;
  overflow: hidden;
  align-items: center;

  margin-inline: 10px;
`

const QuickOptions = styled.div`
  display: grid;
  grid-auto-columns: 1fr;
  grid-auto-flow: column;
  gap: 2px;
`

const StartContent = styled.span`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: auto;
  gap: 8px;
  align-items: center;
`
